<script>
  import Blocks from "$lib/Blocks/index.svelte";
  import Seo from "$lib/Seo.svelte";
  import { fade } from "$lib/transitions.js";
  import layout from "$lib/layout.js";

  export let data;

  $: ({ page } = data);

  $: if (page._meta.uid) {
    $layout.hero =
      page.body && page.body[0] && page.body[0].__typename === "PageBodyHero";
  }
</script>

<Seo {page} title={page.title[0].text} description={page.description} />

{#key page._meta.uid}
  <div
    class="inset-x-0"
    in:fade|global={{ delay: 250, duration: 250 }}
    out:fade|global={{ duration: 250, absolute: true }}
  >
    {#if !$layout.hero}
      <div class="h-16" />
    {/if}
    <Blocks blocks={page.body || []} />
  </div>
{/key}
